import React, { useState } from 'react';
import { Button, Modal, Row, Col, Card } from 'antd';
import { IPlan } from '../../../types/plans';
import { useQuery } from '@apollo/client';
import { queries } from '../../../graphql/graphql';
import { Loader } from '../../UI/Loader';
import { IProductConfigurator } from '../../../types/product';

interface FindConfiguratorProps {
  value?: string;
  plan?: IPlan;
  onChange?: (value: string) => void;
}

export const FindConfigurator = ({ value = '', onChange, plan }: FindConfiguratorProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data = {}, loading } = useQuery(queries.FIND_CONFIGURATOR, {
    variables: { decorId: plan?.decorId, id: plan?.id },
    skip: !plan,
  });
  const { findConfigurator } = data;

  if (!plan) return null;

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onAdd = (id: string) => {
    onChange?.(`https://3d.homewip.com/#!/configurator/${id}`);
    setIsModalOpen(false);
  };

  const getDate = (str: string) => {
    const date = new Date(str);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const formattedTime = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

    return `${formattedDate} ${formattedTime}`;
  };
  return (
    <>
      <Button type="primary" onClick={showModal}>
        Find Configurators
      </Button>
      <Modal
        title="Configurators"
        width={{
          xs: '90%',
          lg: '60%',
        }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}>
        {loading ? (
          <Loader />
        ) : (
          <Row gutter={[16, 16]}>
            {findConfigurator &&
              findConfigurator.configurators &&
              findConfigurator.configurators.length &&
              findConfigurator.configurators.map(
                (configurator: IProductConfigurator) =>
                  configurator.product && (
                    <Col key={configurator._id} span={24} lg={8}>
                      <Card
                        style={{
                          border:
                            value.indexOf(`${configurator.product}`) > 0
                              ? '2px solid green'
                              : '1px solid #f0f0f0',
                        }}
                        hoverable
                        actions={[
                          <Button
                            key="model-view"
                            type="link"
                            onClick={() =>
                              window.open(
                                `https://3d.homewip.com/#!/configurator/${configurator.product}`
                              )
                            }>
                            View
                          </Button>,
                          <Button
                            key="model-product"
                            type="link"
                            onClick={() =>
                              window.open(
                                `https://3d.homewip.com/#!/product/${configurator.product}`
                              )
                            }>
                            Product
                          </Button>,
                          <Button
                            key="model-add"
                            type="primary"
                            onClick={() => onAdd(configurator.product)}>
                            Add
                          </Button>,
                        ]}>
                        <Card.Meta
                          title={configurator.name}
                          description={
                            <>
                              <p>Created at: {getDate(configurator.createdAt)}</p>
                            </>
                          }
                        />
                      </Card>
                    </Col>
                  )
              )}
          </Row>
        )}
      </Modal>
    </>
  );
};
